import { Component, OnInit, Input } from '@angular/core';
import { FormElementEmailOptIn } from '../shared/model/email-optin/form-element-email-optin.model';
@Component({
  selector: 'wl-form-builder-email-optin-display-element',
  templateUrl: 'form-builder-email-optin-display-element.component.html',
    standalone: false
})
export class FormBuilderEmailOptInDisplayElementComponent {
  @Input('emailOptInData') emailOptInData: FormElementEmailOptIn;
  constructor() {}
  ngOnInit(): void {}
}
